import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { withRouter } from "../../withRouter"; 	// HOC pour React Router v6
import { Checkbox, FormControlLabel } from "@mui/material";


class SubseasonAdmin extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			subSeason: {},
			divisions: [],
			teamDiv: [],
			newDivName: '',
			msgSaved: '',
		};
	
		this.loadData = this.loadData.bind(this);
		this.getSubSeason = this.getSubSeason.bind(this);
		this.getDivisions = this.getDivisions.bind(this);
		this.getTeamDiv = this.getTeamDiv.bind(this);
		this.divisionsTable = this.divisionsTable.bind(this);
		this.handleSubSeasonNameChange = this.handleSubSeasonNameChange.bind(this);
		this.handleSubSeasonStartDateChange = this.handleSubSeasonStartDateChange.bind(this);
		this.handleSubseasonTypeFinalsChange = this.handleSubseasonTypeFinalsChange.bind(this);

		this.createDivRow = this.createDivRow.bind(this);
		this.handleDelDiv = this.handleDelDiv.bind(this);
		this.handleNewDivision = this.handleNewDivision.bind(this);
		this.handleNewDivChange = this.handleNewDivChange.bind(this);
		this.createTeamDivRow = this.createTeamDivRow.bind(this);
		this.handleDivChange = this.handleDivChange.bind(this);
		this.handleSaveClick = this.handleSaveClick.bind(this);

		this.savedMsgSet = this.savedMsgSet.bind(this);
		this.savedMsgUnset = this.savedMsgUnset.bind(this);
	}

 	componentDidMount() {
		// console.log('SubseasonAdmin: componentDidMount');
		this.loadData(this.props);
	}

	componentDidUpdate(prevProps) {
	  if (prevProps.ssid !== this.props.ssid) {
	    this.loadData(this.props);
	  }
	}

	loadData(props) {
		const { season } = props;
		var subSeason = {};
		var divisions = [];
		var teamDiv = [];

    if (season._id !== undefined) {
	    Axios.get('/api/teams/season/' + season._id).then(response => {

      	var teams = response.data;
				this.getSubSeason(season, subSeason);
				this.getDivisions(subSeason, divisions);
				this.getTeamDiv(teams, subSeason, teamDiv);

				//console.log('subSeason', subSeason)
				//console.log('divisions', divisions)
				//console.log('teamDiv', teamDiv)
        this.setState({
					subSeason: subSeason,
					divisions: divisions,
					teamDiv: teamDiv,
        });
      });
   	}
	}

	getSubSeason(season, subSeason) {
		// console.log('SubseasonAdmin: getSubSeason');
		var subSeasons = season.subSeasons;
		const { ssid } = this.props;

		/* Get subSeason info from season */
		if (subSeasons) {
			subSeasons.forEach(subSeasonItem => {
				if(subSeasonItem.id === ssid) {

					// copy object properties
					for (var attrname in subSeasonItem) { 
						subSeason[attrname] = subSeasonItem[attrname];
					}

      		var startDate = subSeasonItem.startDate;
      		if ((startDate === null) || (startDate === '')) {
	        	var todaysDate = new Date();
	        	startDate = todaysDate;
	        }
					subSeason.startDate = moment(startDate).utc().format("YYYY-MM-DD");
				}
      });
		}
	}

	getDivisions(subSeason, divisions) {
		// console.log('SubseasonAdmin: getDivisions');
		if (subSeason.divisions) {
			for (var idx = 0; idx < subSeason.divisions.length; idx++) {
				divisions[idx] = subSeason.divisions[idx];
			}
		}
	}

	getTeamDiv(teams, subSeason, teamDiv) {
		console.log('SubseasonAdmin: getTeamDiv');
		console.log(this.props.season, teams, subSeason, teamDiv);


		var seasonDoc = [];
		var subSeasonItem = {};
		var divisionsArray = [];
		
		/* Get subSeason info from season */
		if (teams) {
			// Parse teams array and build teamDiv array
			teams.forEach(function (teamItem) {

				var teamDivItem = {};
				if(subSeason.divisions.length > 0) {
					// [2022-11-21] NO DIVISION OPTION
					teamDivItem.div = "NO DIV"; 	// subSeason.divisions[0].name;	// default to first item
				} else {
					teamDivItem.div = "";	// empty
				}

				// then look if it's included in a division, and set it
				subSeason.divisions.forEach(function (divItem, divIdx, divArray) {

					teamDivItem._id = teamItem._id;
					teamDivItem.name = teamItem.name;

					// check if team exists in div
					if (divItem.teams.includes(teamItem._id)) {
						teamDivItem.div = divItem.name;
					}
				});

				teamDiv.push(teamDivItem);
			});
		}
	}

  render() {
		//console.log('SubSeasonAdmin: RENDER');
		//console.log(this.state.season._id);
		//console.log("divisions")
		//console.log(this.state.divisions)
		//console.log("teamDiv")
		//console.log(this.state.teamDiv)
  	const { ssid } = this.props;
  	const { subSeason, teamDiv, newDivName, msgSaved } = this.state;

    var defaultDate = new Date();
    defaultDate = moment(defaultDate.toISOString()).utc().format("YYYY-MM-DD");

		return (
			<div className="row">
			<div className="col-md-12">

				<div className="card">

					<div className="card-header">
					<i className="fa fa-th-large card-header-text"></i>
						<span className="card-header-text">Sous-saison: [{ssid}] {subSeason.name}</span>
 					</div>


					<div className="card-block">

						<div className="row">
						<div className="col-md-6">

							<h6>Paramètres généraux</h6>

							<div className="input-seasonAdminA">
							Nom de la sous-saison
							<input type="text" className="form-control" id="subSeasonName" value={subSeason.name || ''} 
								placeholder="" onChange={this.handleSubSeasonNameChange} />
							</div>

							<div className="input-seasonAdminA">
							Date de départ
							<input type="date" className="form-control" id="subSeasonStartDate" 
								value={subSeason.startDate || defaultDate} 
								placeholder="" onChange={this.handleSubSeasonStartDateChange} />
							</div>

							<FormControlLabel
							  label="Finales de ligue (pas de points de ronde)"
							  control={
							    <Checkbox 
							      color="success" checked={subSeason.typeFinals || false} 
							      onChange={this.handleSubseasonTypeFinalsChange} /> }
							/>
							<hr/>

							<h6>Liste des Divisions</h6>
							{this.divisionsTable()}
							<hr/>

							<div className="input-seasonAdminA">
					  	Ajouter une nouvelle division <br/>
		 					<input type="text" className="form-control" id="divName" placeholder="Nom de la division" 
								value={newDivName || ''} onChange={this.handleNewDivChange}/>
							<br/>
	 						</div>

							<button type="button" className="btn btn-primary" 
								onClick={this.handleNewDivision}>Ajouter la division</button>
							<hr/>
	
							<span className="redBoldText"> {msgSaved} </span><br/>
							<button type="submit" className="btn btn-primary" onClick={this.handleSaveClick}>
								Sauvegarder la sous-saison</button>

	 					</div>

						<div className="col-md-6">

							<h6>Liste des Équipes</h6>
							<table className="table table-striped table-hover table-sm">
							<tbody>
		      		<tr>
								<th>Équipes</th>
								<th>Division</th>
		         	</tr>
		        	{teamDiv.map(this.createTeamDivRow)}
							</tbody>
		          </table>
						</div>
						</div>
		
					</div>

					<br/><br/>
					<br/>

 				</div>
			</div>
			</div>
    );
  }

	handleSubSeasonNameChange(e) {
		let { subSeason } = this.state;
		subSeason.name = e.target.value;
		this.setState({subSeason: subSeason});
		this.savedMsgUnset("Changements non-sauvegardés...");
	}

	handleSubSeasonStartDateChange(e) {
		let { subSeason } = this.state;
		subSeason.startDate	= e.target.value;
		this.setState({subSeason: subSeason});
		this.savedMsgUnset("Changements non-sauvegardés...");
	}

	handleSubseasonTypeFinalsChange(e) {
		let { subSeason } = this.state;
		subSeason.typeFinals = e.target.checked;
		this.setState({subSeason: subSeason});
		this.savedMsgUnset("Changements non-sauvegardés...");
	}

  // Test pour avoir du contenu conditionnel en gérant les exigences des tags
  // ex: <i> ne peut pas être à l'intérieur d'une <table> ou de <tbody>
  divisionsTable() {
		let { divisions } = this.state;

		if (divisions.length === 0) {
  		return (
				<div>
					<i>Aucune division enregistrée</i>
				</div>
			);
  	} else {
  		return (
 				<table className="table table-striped table-hover table-sm">
  			<tbody>
          <tr>
						<th>Divisions</th>
						<th></th>
          </tr>
  				{divisions.map(this.createDivRow)}
				</tbody>
				</table>
			);
  	}
 	}

  createDivRow(divItem, divIdx) {
		return (
			<tr key={'div.' + divIdx}>
				<td>{divItem.name}</td>
  	    <td className="text-right">
        	<input id={'DelDiv.' + divIdx} type="button" onClick={this.handleDelDiv} value="X"/>
        </td>
      </tr>
    );
  }

	handleDelDiv(e) {
		var dIdx = e.target.id.split(".")[1];
		var divisions = this.state.divisions;
		divisions.splice(dIdx, 1);
		this.setState({divisions: divisions});
		this.savedMsgUnset("Changements non-sauvegardés...");
	}

  handleNewDivision(e) {
  	let { divisions, teamDiv, newDivName } = this.state;
  	var bSameDivName = false;

  	// check if this division name already exists 
  	divisions.forEach(function (divItem) {
  		if(newDivName === divItem.name) {
			bSameDivName = true;
  		}
  	});
    	
  	if(bSameDivName) { 
			alert('Nom de division existant');
  		return; 
  	}

		divisions.push({
			name: newDivName,
			teams: []
		});

		// if no division was present, set all teams divisions to this one
		if(divisions.length === 1) {
			teamDiv.forEach(function (teamDivItem) {
				teamDivItem.div = newDivName;
			});
		}

		this.setState({
			newDivName: '', 
			divisions: divisions,
			teamDiv: teamDiv
		});

		this.savedMsgUnset("Changements non-sauvegardés...");
	}

	handleNewDivChange(e) {
		this.setState({
			newDivName: e.target.value,
		});
	}

  createTeamDivRow(teamDivItem, teamDivIdx) {
		return (
			<tr key={'te.' + teamDivIdx}>
				<td>{teamDivItem.name}</td>
				<td>
	        <select className="form-control" id={"divSelect." + teamDivIdx} 
        		value={teamDivItem.div} onChange={this.handleDivChange}>

        		{/* [2022-11-21] NO DIVISION OPTION */}
			      <option value="NO DIV" key='div.NODIV'>AUCUNE DIVISION</option>
            {this.state.divisions.map(this.createSelectDivItem)}
	        </select>
				</td>
      </tr>
    );
  }

  createSelectDivItem(divItem, divIdx) {
    return (
      <option value={divItem.name} key={'div.' + divIdx}>{divItem.name}</option>
    );
  }

	handleDivChange(e) {
		var tIdx = e.target.id.split(".")[1];
		var teamDiv = this.state.teamDiv;

		teamDiv[tIdx].div = e.target.value;
		this.setState({teamDiv: teamDiv});
		this.savedMsgUnset("Changements non-sauvegardés...");
	}

	handleSaveClick() {
		let { season, ssid, reloadSeason } = this.props;
		let { subSeason, divisions, teamDiv } = this.state;

		// build divisions objects
		divisions.forEach(function (divItem, divIdx, divArr) {

			divItem.teams.splice(0, divItem.teams.length);		// emptying array
			teamDiv.forEach(function (teamDivItem, teamDivIdx) {

				if(divItem.name === teamDivItem.div) {
					divItem.teams.push(teamDivItem._id);
				}
			})
		})

		// Post to DB
		Axios.post('/api/seasons/subSeason/update', {
			seasonObjId: season._id,
			subSeasonId: String(ssid),
			subSeasonName: subSeason.name,
			startDate: subSeason.startDate,
			divisions: divisions,
			typeFinals: subSeason.typeFinals
		})
		.then(response => {
			//console.log(response);
			reloadSeason();
		})
		.catch(function(error) {
			console.log(error);
		});

		this.savedMsgSet();
 	}

  savedMsgSet() {
		this.setState({ msgSaved: "Saison sauvegardée !" });
  }

  savedMsgUnset(msgStr) {
		this.setState({ msgSaved: msgStr });
  }

}

export default withRouter(SubseasonAdmin);